import { render, staticRenderFns } from "./model_67.vue?vue&type=template&id=b6628c42&scoped=true"
import script from "./model_67.vue?vue&type=script&lang=js"
export * from "./model_67.vue?vue&type=script&lang=js"
import style0 from "./model_67.vue?vue&type=style&index=0&id=b6628c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6628c42",
  null
  
)

export default component.exports